import { useState, type InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { Eye, EyeOff } from 'lucide-react'
import styles from './PasswordField.module.css'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & { inputClassName?: string }

export function PasswordField({ inputClassName, disabled, ...rest }: Props) {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  return (
    <span className={styles.wrap}>
      <input
        {...rest}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
        className={`${inputClassName ?? ''} ${styles.input}`}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
      />
      <button
        type="button"
        className={styles.toggle}
        disabled={disabled}
        aria-pressed={visible}
        aria-label={visible ? t('mobile.password.hide') : t('mobile.password.show')}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? <EyeOff size={20} aria-hidden /> : <Eye size={20} aria-hidden />}
      </button>
    </span>
  )
}
